export default __webpack_public_path__ + "b82e166068274bf09a9a315ff5d3875e.svg";